export default __webpack_public_path__ + "static/media/fountain.95389f85.jpeg";